import { fetchAPI } from "./utils";

export interface NormalizationAudioItem {
    audiotrackId: string;
    waypointId: string;
    waypointLocalizedId: string;
    waypointPosition: number;
    waypointName: string;
    language: string;
    currentUrl: string;
    currentKey: string | null;
    originalKey: string | null;
    isNormalized: boolean;
    version: number;
    lufs: number | null;
    truePeak: number | null;
    measuredAt: string | null;
}

export interface TrackAudiosResponse {
    track: { id: string; internalName: string | null };
    items: NormalizationAudioItem[];
}

export interface AnalyzeResult {
    audiotrackId: string;
    lufs: number;
    truePeak: number;
    lra: number;
}

export interface NormalizeResult {
    audiotrackId: string;
    skipped: boolean;
    reason?: string;
    targetLufs: number;
    originalLufs: number;
    originalTruePeak: number;
    normalizedLufs?: number;
    normalizedTruePeak?: number;
    newUrl?: string;
    newKey?: string;
}

export interface AudioVersion {
    key: string;
    url: string;
    version: number;
    label: string;
    isActive: boolean;
    lufs: number | null;
    truePeak: number | null;
    targetLufs: number | null;
    mode: string | null;
    measuredAt: string | null;
}

export interface VersionsResponse {
    audiotrackId: string;
    versions: AudioVersion[];
}

export interface ActivateResult {
    audiotrackId: string;
    previousUrl: string;
    currentUrl: string;
}

export const getTrackAudios = (token: string, trackId: string) =>
    fetchAPI<TrackAudiosResponse>(`/audio-normalization/track/${trackId}`, "GET", undefined, token);

export const analyzeAudioLufs = (token: string, audiotrackId: string) =>
    fetchAPI<AnalyzeResult>("/audio-normalization/analyze", "POST", { audiotrackId }, token);

export const normalizeAudio = (
    token: string,
    audiotrackId: string,
    options: { force?: boolean; targetLufs?: number; linear?: boolean } = {},
) =>
    fetchAPI<NormalizeResult>(
        "/audio-normalization/normalize",
        "POST",
        {
            audiotrackId,
            force: !!options.force,
            targetLufs: options.targetLufs,
            linear: !!options.linear,
        },
        token,
    );

export const listAudioVersions = (token: string, audiotrackId: string) =>
    fetchAPI<VersionsResponse>(`/audio-normalization/versions/${audiotrackId}`, "GET", undefined, token);

export const activateAudioVersion = (token: string, audiotrackId: string, targetUrl: string) =>
    fetchAPI<ActivateResult>("/audio-normalization/activate", "POST", { audiotrackId, targetUrl }, token);
